import { View } from "@gluestack-ui/themed";
import { Modal } from "@repo/core/components/layout/Modal";
import { IModalRefProps } from "@repo/core/components/layout/Modal/types";
import { ProposalsFilters } from "@repo/core/screens/Proposals/components/ProposalsFilters";
import ProposalsScreens from "@repo/core/screens/Proposals";
import { useRef } from "react";

export const ProposalsList = () => {
  const modalRef = useRef<IModalRefProps>(null);

  const handleFilterPress = () => {
    modalRef.current?.open();
  };

  const handleCloseFilter = () => {
    modalRef.current?.close();
  };

  return (
    <>
      <ProposalsScreens.Search onFilterPress={handleFilterPress} />
      <Modal ref={modalRef}>
        <View p="$2" bg="$backgroundLight0">
          <ProposalsFilters onCloseFilter={handleCloseFilter} />
        </View>
      </Modal>
    </>
  );
};
